module.exports = __webpack_public_path__ + "img/16-5.fc6d1980.png";